import type { DateTimeValue } from '@elfsight/configurator-contracts';

export type RepeatPeriodValue =
  | 'noRepeat'
  | 'daily'
  | 'weeklyOn'
  | 'weekday'
  | 'annuallyOn'
  | 'custom'
  | 'nthDayInMonth'
  | 'lastDayInMonth';

export type RepeatFrequencyValue =
  | 'daily'
  | 'weeklyOn'
  | 'monthly'
  | 'annuallyOn';

export type RepeatWeeklyOnDaysValue = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type RepeatMonthlyOnDayValue =
  | 'sameDayInMonth'
  | 'nthDayInMonth'
  | 'lastDayInMonth';

export type repeatEndsValue = 'never' | 'onDate' | 'afterOccurrences';

export type ScheduleDefaultsType = {
  scheduleStart: DateTimeValue<'datetime'> | undefined;
  scheduleEnd: DateTimeValue<'datetime'> | undefined;
  scheduleIsAllDay: boolean;
  scheduleTimeZone: string | undefined;
  scheduleRepeatPeriod: RepeatPeriodValue;
  scheduleRepeatFrequency: RepeatFrequencyValue;
  scheduleRepeatInterval: number;
  scheduleRepeatWeeklyOnDays: RepeatWeeklyOnDaysValue[];
  scheduleRepeatMonthlyOnDay: RepeatMonthlyOnDayValue;
  scheduleRepeatEnds: repeatEndsValue;
  scheduleRepeatEndsDate: DateTimeValue<'datetime'> | undefined;
  scheduleRepeatEndsOccurrences: number;
};

export const scheduleDefaults: ScheduleDefaultsType = {
  scheduleStart: undefined,
  scheduleEnd: undefined,
  scheduleIsAllDay: false,
  scheduleTimeZone: undefined,
  scheduleRepeatPeriod: 'noRepeat',
  scheduleRepeatFrequency: 'daily',
  scheduleRepeatInterval: 1,
  scheduleRepeatWeeklyOnDays: [1],
  scheduleRepeatMonthlyOnDay: 'sameDayInMonth',
  scheduleRepeatEnds: 'never',
  scheduleRepeatEndsDate: undefined,
  scheduleRepeatEndsOccurrences: 1
};
